var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.832 6.16634H13.1654V8.49967H10.832V6.16634ZM10.832 10.833H13.1654V17.833H10.832V10.833ZM11.9987 0.333008C5.5587 0.333008 0.332031 5.55967 0.332031 11.9997C0.332031 18.4397 5.5587 23.6663 11.9987 23.6663C18.4387 23.6663 23.6654 18.4397 23.6654 11.9997C23.6654 5.55967 18.4387 0.333008 11.9987 0.333008ZM11.9987 21.333C6.8537 21.333 2.66536 17.1447 2.66536 11.9997C2.66536 6.85468 6.8537 2.66634 11.9987 2.66634C17.1437 2.66634 21.332 6.85468 21.332 11.9997C21.332 17.1447 17.1437 21.333 11.9987 21.333Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.8676064a275118e09b531304aa9e7efc.svg";
export { ForwardRef as ReactComponent };